import React from 'react'
import { cx, css } from '@emotion/css';
import { InfiniteScrollTable, Icon, Truncate } from '../../../../../../../../../../index'
import { formatTime, getAssetType } from '../../util';
import styles from './index.module.css'

const GetIcon = ({ data }) => {
  let icon = getAssetType(data.content_type);
  let backgroundUrl = data.url ? `url(${data.url})` : 'inherit';
  return (
    <React.Fragment>
      <span className={cx(styles['list-icon'], css`
        background: ${backgroundUrl};
      `)}>
        {icon && <Icon icon={icon} />}
      </span>
      <div className='data-title'>
        <Truncate isResponsive truncateFrom='end'>
          {data.name ? data.name : data.title}
        </Truncate>
      </div>
    </React.Fragment>
  )
}

export const ListView = ({ state, fetchOnChange, loadMore, handleClick, loading, users }) => {
  const columns = [
    {
      Header: 'Title',
      id: 'title',
      accessor: (data) => {
        return (
          <div className='flex-v-center w-100'>
            <GetIcon data={data} />
          </div>
        )
      },
      default: false,
      addToColumnSelector: true,
    },
    {
      Header: 'Unique ID',
      accessor: 'uid',
      default: false,
      addToColumnSelector: true,
      disableSortBy: true,
    },
    {
      Header: 'Last Modified',
      accessor: (data) => <div className={'last-updated-by'}><span>{users?.[data?.updated_by] || 'Anonymous'}</span> <span className='last-updated-by-time'>{formatTime(data?.updated_at)}</span></div>,
      default: false,
      addToColumnSelector: true,
      disableSortBy: true,
    },
  ]

  return (
    <div className={cx('scrte-infinite-list', css`
      overflow: hidden;
    `)}>
      <InfiniteScrollTable
        tableHeight={400}
        data={state.assets}
        columns={columns}
        uniqueKey={'uid'}
        fetchTableData={fetchOnChange}
        loadMoreItems={loadMore}
        loading={loading}
        totalCounts={state.count}
        onRowClick={handleClick}
        singleSelectedRowId={state.selectedImage.uid}
        itemStatusMap={state.itemStatusMap}
        columnSelector={false}
        minBatchSizeToFetch={30}
        name={{ singular: 'Asset', plural: 'Assets' }}
      />
    </div>
  )
}
